module.exports = __webpack_public_path__ + "static/img/wall-conveyor-x3-steel_256.0b21541.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wall-conveyor-x3-steel_256.png
// module id = 2OwC
// module chunks = 0